import { useEffect, useState } from 'react';

export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(window?.matchMedia?.(query).matches ?? false);

  useEffect(() => {
    const mediaQueryList = window.matchMedia?.(query);
    if (!mediaQueryList) return undefined;

    const onChange = () => setMatches(mediaQueryList.matches);
    // Modern browsers
    if (typeof mediaQueryList.addEventListener === 'function') {
      mediaQueryList.addEventListener('change', onChange);
    } else {
      // Legacy Safari (avoid deprecated typing warnings by using `any`)
      (mediaQueryList as any).addListener?.(onChange);
    }

    setMatches(mediaQueryList.matches);

    return () => {
      if (typeof mediaQueryList.removeEventListener === 'function') {
        mediaQueryList.removeEventListener('change', onChange);
      } else {
        // Legacy Safari (avoid deprecated typing warnings by using `any`)
        (mediaQueryList as any).removeListener?.(onChange);
      }
    };
  }, [query]);

  return matches;
};
